import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "../../components/Page";

import GamePlay from "./GamePlay";
import GameFilter from "./GameFilter";
import Email from "./Email";
import Password from "./Password";
import CloseAccount from "./CloseAccount";
import ChessSet from "./ChessSet";

import styles from "./styles/Settings.module.css";
import { FaCog } from "react-icons/fa";
// import { FaTrophy } from 'react-icons/fa';
// import { useRouter } from "next/router";
import Head from "next/head";
import Link from "next/link";

export default function Settings({ page }) {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  // const router = useRouter();
  // const { page } = router.query;

  // console.log("router.query", router.query);

  const activePage = Number(page);

  function renderPage() {
    switch (activePage) {
      case 0:
        return <ChessSet />;
      case 1:
        return <GamePlay />;
      case 2:
        return <GameFilter />;
      case 3:
        return <Email />;
      case 4:
        return <Password />;
      case 5:
        return <CloseAccount />;
      default:
        return <GamePlay />;
    }
  }

  const itemStyles = [
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
  ].map((item, i) => (i === activePage ? item + " " + styles.active : item));

  return (
    <Page title={t("Settings")} icon={<FaCog />}>
      <Head>
        <title>{"Chess Hotel | " + t("Settings")}</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      <div className={styles.wrapper}>
        <div className={styles.sidebar}>
          <Link className={itemStyles[0]} href="/settings/0">
            {settingsT("Chess sets")}
          </Link>
          <Link className={itemStyles[1]} href="/settings/1">
            {settingsT("Game behavior")}
          </Link>
          <Link className={itemStyles[2]} href="/settings/2">
            {settingsT("Game filter")}
          </Link>
          <Link className={itemStyles[3]} href="/settings/3">
            {settingsT("Update email")}
          </Link>
          <Link className={itemStyles[4]} href="/settings/4">
            {settingsT("Update password")}
          </Link>
          <Link className={itemStyles[5]} href="/settings/5">
            {settingsT("Close account")}
          </Link>
        </div>
        {renderPage()}
      </div>
    </Page>
  );
}
